// userService.js - güncellenmiş versiyon
import api from './api';

// Kullanıcı profil bilgilerini getir
export const getUserProfile = async () => {
    try {
        const response = await api.get('/users/profile');
        return response.data;
    } catch (error) {
        console.error('Profil bilgileri getirme hatası:', error);
        throw error;
    }
};

// Kullanıcı profilini güncelle
export const updateUserProfile = async (profileData) => {
    try {
        const response = await api.put('/users/profile', profileData, {
            headers: {
                'Content-Type': 'multipart/form-data' // FormData için gerekli
            }
        });

        // Kullanıcı bilgilerini yerel depolamada güncelle
        if (response.data.success) {
            const user = JSON.parse(localStorage.getItem('user'));
            // Kullanıcı bilgilerini güncelle
            const updatedUserData = { ...user, user: response.data.user };
            localStorage.setItem('user', JSON.stringify(updatedUserData));
        }

        return response.data;
    } catch (error) {
        console.error('Profil güncelleme hatası:', error);
        throw error;
    }
};

export default {
    getUserProfile,
    updateUserProfile
};